import React, { useEffect } from "react";
import {
  SideNav as SharedNav,
  SideNavHeader,
  GameNavigator,
  Divider,
  SideNavLinksContainer,
  GameNavButton,
  Footer,
  FooterMenu,
  SideNavLink,
  SideNavDropdownLink,
} from "@shared/side-nav";
import { Link, useLocation } from "react-router-dom";
import { useResponsive } from "@outplayed/responsive";
import { ReactComponent as HomeIcon } from "svg/home-icon.svg";
import { ReactComponent as PaperWriting } from "svg/paper-writing.svg";
import { ReactComponent as Skullhead } from "svg/skull-head.svg";
import { ReactComponent as Questionnaire } from "svg/questionnaire-fill.svg";
import { ReactComponent as Arrow } from "svg/left-arrow.svg";
import { ReactComponent as EchoLogo } from "svg/echoLogo.svg";
import { ReactComponent as TrophyIcon } from "svg/trophy.svg";
import classNames from "classnames";
import Searchbar from "./Searchbar";
import { MediaQuery } from "@outplayed/responsive";

const GlobalWrapperLink = (props) => {
  const { path, children } = props;
  return <Link to={path}>{children}</Link>;
};

const SideNav = (props) => {
  const { open, setOpen, autoSearch = false, setAutoSearch } = props;
  const { pathname } = useLocation();
  const { currentBreakpoint } = useResponsive();
  const isMobile = currentBreakpoint?.includes("MOBILE");

  const onMobileClick = () => {
    if (isMobile && open) {
      setOpen(false);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      const sideNav = document.getElementById("side-nav-container");
      const sideNavCssObj = window.getComputedStyle(sideNav, null);
      if (sideNav && !sideNav.contains(e.target)) {
        if (sideNavCssObj["content"] !== '"mobile"') {
          isMobile && setOpen(false);
        }
      }
    };
    window.addEventListener("click", handleOutsideClick);

    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, [open]);

  useEffect(() => {
    const sideNav = document.getElementById("side-nav-container");
    const sideNavCssObj = window.getComputedStyle(sideNav, null);
    if (sideNavCssObj["content"] === '"mobile"') {
      if (open) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    } else {
      document.body.style.overflow = "";
    }
  }, [open]);

  return (
    <SharedNav
      className={classNames("wow-shared-side-nav", { "xs:side-nav_mobile": isMobile })}
      theme={"dark"}
      isOpen={open}
      onMouseEnter={() => {
        !isMobile && setOpen(true);
      }}
      onMouseLeave={() => {
        !isMobile && setOpen(false);
      }}
    >
      <SideNavHeader
        LogoWrapper={({ children }) => {
          if (open) {
            return <Link to="/deadlock/">{children}</Link>;
          }
          return (
            <div
              onClick={(e) => {
                e.stopPropagation();
                setOpen(true);
              }}
            >
              {children}
            </div>
          );
        }}
      />

      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        <Divider marginBottom />
      </MediaQuery>
      <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE" renderNullOnFail>
        {open && (
          <div className="masthead-search-bar-container side-nav-search">
            <Searchbar autoFocus={autoSearch} setSideNavOpen={setOpen} setAutoFocus={setAutoSearch} />
          </div>
        )}
      </MediaQuery>
      <SideNavLinksContainer>
        <SideNavLink
          label="Home"
          path="/deadlock/"
          iconSvg={<HomeIcon />}
          WrapperLink={GlobalWrapperLink}
          onClick={onMobileClick}
          active={pathname === "/deadlock/"}
        ></SideNavLink>
        <SideNavLink
          label="Tier List"
          path="/deadlock/tier-list/"
          iconSvg={<PaperWriting />}
          WrapperLink={GlobalWrapperLink}
          onClick={onMobileClick}
          active={pathname.includes("tier-list")}
        ></SideNavLink>
        <SideNavLink
          label="Heroes"
          path="/deadlock/heroes/"
          iconSvg={<Skullhead />}
          WrapperLink={GlobalWrapperLink}
          onClick={onMobileClick}
          active={pathname === "/deadlock/heroes/"}
        ></SideNavLink>
      </SideNavLinksContainer>
      <Footer>
        <FooterMenu>
          <a onClick={onMobileClick} href="https://u.gg/privacy-policy">
            Privacy Policy
          </a>
          <a onClick={onMobileClick} href="https://u.gg/privacy-shield">
            Privacy Shield
          </a>
          <a onClick={onMobileClick} href="https://u.gg/terms-of-service">
            Terms of Service
          </a>
        </FooterMenu>
      </Footer>
    </SharedNav>
  );
};

export default SideNav;
